import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { ApplicationService } from "../../../services/application.service";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-screen-403",
  templateUrl: "./403.html",
  styleUrls: ["./403.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, TranslatePipe],
})
export class Error_403Component {
  readonly applicationService = inject(ApplicationService);
  readonly translateService = inject(TranslateService);

  public constructor() {
    this.applicationService.updateTitle("Oops!");
  }
}
